import React, { useMemo } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { getGameImages } from '../../../core/helpers/getGameImages';
import { isMobile } from '../../../core/helpers/isMobile';
import BoostedJackpotInitialPopup from './boostedJackpotInitialPopup';
import BoostedJackpotInfoPopup from './boostedJackpotInfoPopup';
import { boostedJackpotStore } from '../../../store/boostedJackpotStore';
import { userSettingsStore } from '../../../store/userSettingsStore';
import BoostedJackpotWinPopup from './boostedJackpotWinPopup';
import BoostedJackpotWheelWrapper from './BoostedJackpotWheelWrapper';

const BoostedJackpot = observer(() => {
  const { isBoostedJackpotInitialPopup } = userSettingsStore;
  const { isBoostedJackpot, wheelValues, isBoostedJackpotInfoPopup, isWheel } = boostedJackpotStore;

  const {
    cursor,
    wheelBtn,
    rulesIcons,
    wheelBorder,
    boostedJackpotInfoPopup,
    boostedJackpotInfoPopupUI,
    boostedJackpotInitialPopup,
    boostedJackpotPopupCloseButton,
    boostedJackpotInfoPopupOkButton,
    boostedJackpotInfoPopupOkButtonHover,
    boostedJackpotInfoPopupOkButtonPressed,
  } = getGameImages();

  const alpha = useMemo(() => {
    return isMobile()
      ? isBoostedJackpotInitialPopup || isBoostedJackpotInfoPopup || isWheel
        ? 0.5
        : 1
      : 1;
  }, [isBoostedJackpotInitialPopup, isBoostedJackpotInfoPopup, isWheel]);

  const {
    containerConfigBoostedJackpotWheel,
    containerConfigBoostedJackpotWinPopup,
    containerConfigBoostedJackpotInfoPopup,
    containerConfigBoostedJackpotInitialPopup,
  } = useMemo(() => {
    return {
      containerConfigBoostedJackpotWheel: {
        x: isMobile() ? 269 : 720,
        y: isMobile() ? 480 : 405,
      },
      containerConfigBoostedJackpotWinPopup: {
        x: isMobile() ? 270 : 720,
        y: isMobile() ? 525 : 406,
      },
      containerConfigBoostedJackpotInfoPopup: {
        x: isMobile() ? 27 : 478,
        y: isMobile() ? 200 : 86,
      },
      containerConfigBoostedJackpotInitialPopup: {
        x: isMobile() ? 22.5 : 341,
        y: isMobile() ? 300 : 148,
        scale: isMobile() ? 0.65 : 1,
      },
    };
  }, [alpha]);

  if (!isBoostedJackpot) {
    return;
  }

  // eslint-disable-next-line consistent-return
  return (
    <Container name='BoostedJackpotContainer'>
      <BoostedJackpotInitialPopup
        boostedJackpotInitialPopup={boostedJackpotInitialPopup}
        boostedJackpotPopupCloseButton={boostedJackpotPopupCloseButton}
        boostedJackpotInfoPopupOkButton={boostedJackpotInfoPopupOkButton}
        boostedJackpotInfoPopupOkButtonHover={boostedJackpotInfoPopupOkButtonHover}
        boostedJackpotInfoPopupOkButtonPressed={boostedJackpotInfoPopupOkButtonPressed}
        containerConfigBoostedJackpotInitialPopup={containerConfigBoostedJackpotInitialPopup}
      />
      <BoostedJackpotInfoPopup
        rulesIcons={rulesIcons}
        boostedJackpotInfoPopup={boostedJackpotInfoPopup}
        boostedJackpotInfoPopupUI={boostedJackpotInfoPopupUI}
        boostedJackpotPopupCloseButton={boostedJackpotPopupCloseButton}
        containerConfigBoostedJackpotInfoPopup={containerConfigBoostedJackpotInfoPopup}
      />
      <BoostedJackpotWheelWrapper
        cursor={cursor}
        wheelBtn={wheelBtn}
        wheelBorder={wheelBorder}
        wheelValues={wheelValues}
        sectors={wheelValues.length}
        containerConfigBoostedJackpotWheel={containerConfigBoostedJackpotWheel}
      />
      <BoostedJackpotWinPopup
        containerConfigBoostedJackpotWinPopup={containerConfigBoostedJackpotWinPopup}
      />
    </Container>
  );
});

export default BoostedJackpot;
